import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/types/user'

export interface PeoplePickerProps {
  people: User[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PeoplePicker',
  props: {
    people: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})